export default __webpack_public_path__ + "assets/images/41604c8f3a3ac2ed7da523fcc3ef9e5a.png";